import { Component, OnInit, Output, EventEmitter, Input, ElementRef, AfterViewChecked } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

export interface CustomDateModel {
  from: Date;
  to: Date;
  oriFrom: Date;
  oriTo: Date;
}

@Component({
  selector: 'app-ega-custom-date-selector',
  templateUrl: './ega-custom-date-selector.component.html',
  styleUrls: ['./ega-custom-date-selector.component.scss'],
  standalone: false
})
export class EgaCustomDateSelectorComponent implements OnInit, AfterViewChecked {
  @Output() applyDate = new EventEmitter<any>();
  @Input() setMinDate = { min: null, max: null, intialRow: null, index: null, isEdit: false };
  @Input() disableEndDate: any;
  @Input() selection: any;
  customDate: CustomDateModel;
  today: Date;
  startDate: Date;
  startDateFrom: Date;
  selectionCorrect: any = false;
  isDisable = {
    from: false,
    to: false
  };
  public endDate: Date;


  threeYearsAgo: Date;
  maxEndDate: Date;
  toCalendarMinDate: Date;
  minYear: number;
  maxYear: number;
  yearRange: string;

  constructor(
    public utilSer: UtilsService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    const thisInstant = +new Date();
    this.today = new Date(this.utilSer.timeStampConverter(thisInstant, false));
    const tempToday = new Date(this.utilSer.timeStampConverter(thisInstant, false));
    this.selectionCorrect = false;

    this.maxYear = this.today.getFullYear();
    this.minYear = this.maxYear - 3;
    this.yearRange = `${this.minYear}:${this.maxYear}`;

    const basethreeYearsAgo = new Date(this.today);
    basethreeYearsAgo.setFullYear(this.minYear);
    this.threeYearsAgo = basethreeYearsAgo;


    if (this.setMinDate && this.setMinDate.min === null && this.setMinDate.max === null) {
      this.startDate = null;
      this.endDate = new Date(this.today.setDate(this.today.getDate() - 1));
      this.isDisable.from = false;
      this.isDisable.to = false;
      this.setMinDate.min = this.today;
      this.setMinDate.max = this.today;
    } else {
      if ((this.disableEndDate && this.disableEndDate.cost && this.selection === 'cost') ||
        (this.disableEndDate && this.disableEndDate.ega &&
          this.selection === 'ega')) {
        this.isDisable.from = true;
        this.isDisable.to = true;
      } else {
        this.isDisable.from = true;
      }
      this.startDate = this.setMinDate.min;
      if (this.disableEndDate && this.setMinDate.max === null) {
        this.setMinDate.max = this.today;
      }
      if (this.setMinDate && this.setMinDate.intialRow) {
        this.isDisable.from = false;
        this.startDate = null;
      }
    }

    if (this.setMinDate && this.setMinDate.index === 0 && !this.setMinDate.isEdit) {
      this.startDateFrom = new Date(tempToday.setDate(tempToday.getDate() - 6));
      this.isDisable.from = false;
    } else {
      this.startDateFrom = this.startDate;
    }

    if (!this.startDateFrom || this.startDateFrom < this.threeYearsAgo) {
      this.startDateFrom = this.threeYearsAgo;
    }

    this.customDate = {
      from: this.setMinDate?.min,
      to: this.setMinDate?.max,
      oriFrom: this.setMinDate?.min,
      oriTo: this.setMinDate?.max,
    };

    this.updateRangeLimits();
    this.customDateChange();
  }

  ngAfterViewChecked(): void {
    this.disabledOutOfRange();
  }


  disabledOutOfRange() {
    const calendarHost = this.el.nativeElement;
    const yearElements: NodeListOf<HTMLElement> = calendarHost.querySelectorAll('.p-yearpicker-year', 'p-yearpicker span', '.ui-yearpicker-year');

    if (yearElements && yearElements.length > 0) {
      yearElements.forEach((el) => {
        const yearVal = parseInt(el.innerText?.trim(), 10);

        if (!isNaN(yearVal)) {
          if (yearVal < this.minYear || yearVal > this.maxYear) {
            el.classList.add('custom-year-disabled');
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.25';
            el.style.color = '#a0a0a0';
            el.style.cursor = 'not-allowed';
          } else {
            el.classList.remove('custom-year-disabled');
            el.style.pointerEvents = 'auto';
            el.style.opacity = '1';
            el.style.color = '';
            el.style.cursor = 'pointer';
          }
        }
      })
    }
  }

  updateRangeLimits() {
    if (this.customDate?.from) {
      this.toCalendarMinDate = this.startDate && this.startDate > this.customDate.from
        ? this.startDate
        : this.customDate.from;

      const maxThreeMonths = this.addMonths(new Date(this.customDate.from), 3);

      if (this.endDate && maxThreeMonths > this.endDate) {
        this.maxEndDate = this.endDate;
      } else {
        this.maxEndDate = maxThreeMonths;
      }

      if (this.customDate.to && +this.customDate.to > +this.maxEndDate) {
        this.customDate.to = new Date(this.maxEndDate);
      }
    } else {
      this.toCalendarMinDate = this.startDate;
      this.maxEndDate = this.endDate;
    }
  }

  customDateChange() {
    this.updateRangeLimits();
    if (this.customDate?.from && this.customDate?.to) {
      const fromTime = +this.customDate.from;
      const toTime = +this.customDate.to;

      const maxDateRange = this.addMonths(new Date(this.customDate.from), 3);

      const isWithin3Years = fromTime >= +this.threeYearsAgo;
      const isValidOrder = fromTime <= toTime;
      const isWithin3Months = toTime <= +maxDateRange;

      this.selectionCorrect = isValidOrder && isWithin3Months && isWithin3Years;
    } else {
      this.selectionCorrect = false;
    }
  }

  addMonths(date: Date, months: number) {
    const result = new Date(date);
    const targetMonth = result.getMonth() + months;
    result.setMonth(targetMonth);
    return result;
  }

  applyCustomDate() {
    // meit converted date (to factory local time)
    const selectedFrom = new Date(new Date(
      this.utilSer.timeStampConverter(+this.customDate.from)).setHours(0, 0, 1, 0));
    const selectedTo = new Date(new Date(
      this.utilSer.timeStampConverter(+this.customDate.to)).setHours(0, 0, 1, 0));
    const converteddate: CustomDateModel = {
      from: selectedFrom,
      to: selectedTo,
      oriFrom: this.customDate.from,
      oriTo: this.customDate.to
    };
    this.applyDate.emit(converteddate);
  }

}
